<template>
  <v-layout row wrap>
    <v-flex xs12 d-flex>
      <slot :hover="hover" name="content"></slot>
      <slot :hover="hover" name="actions"></slot>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    //TODO: Checken ob das sinnvoll ist, hier auch die Severity zu berechnen!
    severity: { type: [String, Number], default: 0 },
    hover: { type: Boolean, default: false }
  }
};
</script>
